module.exports = __webpack_public_path__ + "1f0cbb52b63f3ab6c3ce558fbee5ef06.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/bowtie-s.png
// module id = 1243
// module chunks = 0